
import { FSRS, Card, Rating, createEmptyCard, generatorParameters } from 'ts-fsrs';

// Default parameters
const defaultParams = generatorParameters({
  enable_fuzz: true, // Add some randomness to prevent cards clumping
  request_retention: 0.9, // Default 90% retention
});

export class FSRSService {
  private fsrs: FSRS;

  constructor(retentionRate: number = 0.9) {
    const params = generatorParameters({
        ...defaultParams,
        request_retention: retentionRate
    });
    this.fsrs = new FSRS(params);
  }

  // Create a new card for a new mistake
  createCard(): Card {
    const card = createEmptyCard();
    // Initialize with current time
    card.due = new Date();
    return card;
  }

  // Process a review
  // isCorrect: true = Good (Recall), false = Again (Forgot)
  reviewCard(card: Card, isCorrect: boolean): Card {
    const rating = isCorrect ? Rating.Good : Rating.Again;
    const now = new Date();
    
    // FSRS repeat returns a collection of scheduled cards (RecordLog), we need the one corresponding to the rating
    const schedulingCards = this.fsrs.repeat(card, now);
    
    // schedulingCards[rating].card gives the updated card state
    return schedulingCards[rating].card;
  }

  // Calculate generic 'Good' interval for preview (Optional)
  previewNextInterval(card: Card, isCorrect: boolean): number {
      const rating = isCorrect ? Rating.Good : Rating.Again;
      const now = new Date();
      const schedulingCards = this.fsrs.repeat(card, now);
      return schedulingCards[rating].card.scheduled_days;
  }
  
  // Re-initialize with new retention rate
  updateRetentionRate(rate: number) {
      const params = generatorParameters({
        ...defaultParams,
        request_retention: rate
    });
    this.fsrs = new FSRS(params);
  }
}
